// extracted by mini-css-extract-plugin
export default {"text":"WriteWords_text__4ppE+"};